import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const MagnifyingGlass: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    {...props}
  >
    <style type="text/css">
      {
        '\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#002677;}\n\t.st2{fill:#FF612B;}\n'
      }
    </style>
    <g id="white_space" />
    <g id="Layer_1">
      <circle className="st0" cx={19.9877} cy={20.2934} r={13.0243} />
      <g>
        <path
          className="st1"
          d="M33.1099,28.3235c1.7627-2.8399,2.644-6.3653,2.1544-10.0865c-0.9793-6.9528-6.5611-12.4368-13.416-13.3181 C11.8597,3.7437,3.438,12.1655,4.6131,22.154c0.8813,6.8549,6.3653,12.4368,13.2202,13.3181 c3.7212,0.4896,7.2466-0.3917,10.0865-2.1544l9.401,8.8134c2.2523,2.2523,6.1694,0.6855,6.1694-2.5461l0,0 c0-0.9793-0.3917-1.8606-1.0772-2.5461L33.1099,28.3235z M19.9877,33.2198c-7.1487,0-13.0243-5.8756-13.0243-13.0243 S12.7411,7.2691,19.9877,7.2691S33.012,13.1447,33.012,20.2934S27.1364,33.2198,19.9877,33.2198z"
        />
      </g>
      <g>
        <path
          className="st2"
          d="M10.6685,20.1938c-0.0503,0-0.1016-0.0029-0.1528-0.0093c-0.6855-0.0835-1.1729-0.707-1.0894-1.3921 c0.5498-4.5029,4.0503-8.2178,8.5122-9.0342c0.6792-0.1274,1.3301,0.3252,1.4546,1.0044s-0.3257,1.3306-1.0044,1.4546 c-3.3975,0.6216-6.0625,3.4497-6.481,6.8779C11.8306,19.729,11.2915,20.1938,10.6685,20.1938z"
        />
      </g>
    </g>
  </Box>
)
export default MagnifyingGlass
